import React, { createContext, useEffect, useMemo, useState } from "react";

import { getTramite } from '../services/tramiteService';
import { useAlert } from '../hooks/useAlert';
const TramiteContext = createContext();

export const TramiteProvider = (props) => {
  const [tramite, setTramite] = useState(null);//tramite seleccionado
  const [loading, setLoading] = useState(false);
  const { errorAlert } = useAlert();

  const refreshData = () => {
    if (tramite?.id) {
      setLoading(true);
      getTramite({ id: tramite.id }).then(r => {
        setTramite(r);
      }).catch(err => errorAlert({
        exception: err,
      })).finally(() => setLoading(false));
    }
  }
  
  return <TramiteContext.Provider value={{
    tramite,
    setTramite,
    loading,
    refreshData
  }} {...props} />
};

export default TramiteContext;